import React from "react";
import "./comp4.css"

class Comp4 extends React.Component {
  render() {
    return (
      <div className="comp4" data-part-id="container" size={1}>
        <p className="comp4_1" data-part-id="text" size={5}>
          We want to make web development accessible to everybody and give automation control to non-technical creators.
        </p>
        <p className="comp4_2" data-part-id="text" size={5}>
          Extract the look and feel from websites and generate a production ready prototype, without writing code.
        </p>
      </div>
    );
  }
}

export default Comp4;
